export const errors = {
    'Invalid login credentials': 'Usuário/senha inválidos',
}